import type { IconColorClass } from "@/playground/components/DevHome/table/components/IconWithTooltip/IconWithTooltip.decl";
import SvgVirtualAgentFilled from "@/playground/components/DevHome/table/components/VirtualAgentFilled/VirtualAgentFilled";
import { PhoneIncoming, PhoneOutgoing, Voicemail } from "@aircall/react-icons";
import type { ComponentType } from "react";

export type CallType = "INBOUND" | "OUTBOUND" | "VOICEMAIL" | "VIRTUAL_AGENT";

// Icon rendered by IconWithTooltip as `<Icon className width height />`: a
// local prop shape (matches IconWithTooltip's own) so we don't depend on
// tractor's IconProps.
type CellIconComponent =
  | string
  | ComponentType<{
      className?: string;
      width?: number | string;
      height?: number | string;
    }>;

export type CallTypeMapProps = {
  [key in CallType]: {
    tooltip: string;
    color: IconColorClass;
    icon: CellIconComponent;
    dataTest: string;
  };
};

export const callTypeMap: CallTypeMapProps = {
  INBOUND: {
    icon: PhoneIncoming,
    color: "text-primary",
    tooltip: "inbound_call",
    dataTest: "icon-inbound-call",
  },
  OUTBOUND: {
    icon: PhoneOutgoing,
    color: "text-info",
    tooltip: "outbound_call",
    dataTest: "icon-outbound-call",
  },
  VOICEMAIL: {
    icon: Voicemail,
    color: "text-warning",
    tooltip: "voicemail_call",
    dataTest: "icon-voicemail-call",
  },
  VIRTUAL_AGENT: {
    icon: SvgVirtualAgentFilled,
    color: "text-warning",
    tooltip: "voicemail_call",
    dataTest: "icon-virtual-agent-call",
  },
};
